import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { PipedriveIcon, PipedriveSearchResultIcon } from './icon';

export const pipedriveConfig: ThirdPartyConfig = {
	displayName: 'Pipedrive',
	id: 'pipedrive',
	resourceType: ProductResourceTypes3P.Pipedrive,
	icon: get3PLogo(PipedriveIcon, 'Pipedrive', 'medium'),
	searchResultIcon: get3PLogo(PipedriveSearchResultIcon, 'Pipedrive', 'large'),
	integrationAri: 'ari:cloud:platform::integration/pipedrive',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Deal,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Deal],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
